module.exports = __webpack_public_path__ + "img/43_63.1ba79f49.png";